import * as S from './styles';

interface LoaderProps {
  className?: string;
  color?: string;
}

export function Loader({ className, color }: LoaderProps) {
  return (
    <S.LoaderContainer className={className} color={color}>
      <div />
    </S.LoaderContainer>
  );
}
